import { ColDef } from 'ag-grid-enterprise';
import { DocumentCapTableResponse } from '~/api/def/endpoints/document/documentCapTableEndpoint';
import { OptionCell } from './OptionCell';
import { ShareholderCell } from './ShareHolderCell';

export type DocumentOverviewCapTableRow = DocumentCapTableResponse & {
  handleDelete: () => void;
  handleEdit: () => void;
  scrollToHighlight: (fieldId: string) => void;
  options?: string;
  isFundInvestment?: boolean;
};

export const colDefsDocumentOverviewCapTable: ColDef<DocumentOverviewCapTableRow>[] =
  [
    {
      field: 'shareholder',
      headerName: 'Shareholder',
      sortable: true,
      cellClass: 'flex align-items-center justify-content-left',
      cellStyle: function (props) {
        return props.data?.shareClassIsNormalized
          ? { color: 'var(--bq-color-warn)' }
          : null;
      },
      type: 'w120',
      filter: true,
      cellRenderer: ShareholderCell,
    },
    {
      field: 'isFundInvestment',
      headerName: 'Fund Investment',
      sortable: true,
      cellClass: 'flex align-items-center justify-content-center',
      type: 'w120',
      filter: true,
      valueFormatter: (params) => {
        return params.value ? '✓' : '';
      },
      cellStyle: (params) => {
        return params.value ? { color: 'var(--bq-color-success)' } : null;
      },
    },
    {
      field: 'shareClass',
      headerName: 'Share Class',
      sortable: true,
      cellClass: 'flex align-items-center justify-content-left',
      type: 'w120',
      filter: true,
      cellStyle: function (props) {
        return props.data?.shareClassIsNormalized
          ? { color: 'var(--bq-color-warn)' }
          : null;
      },
    },
    {
      field: 'shareCount',
      headerName: 'Share count',
      sortable: true,
      cellClass: 'flex align-items-center justify-content-left',
      type: 'w120',
      filter: true,
    },
    {
      field: 'investmentAmount',
      headerName: 'Investment Amount',
      sortable: true,
      cellClass: 'flex align-items-center justify-content-left',
      type: 'w120',
      filter: true,
    },
    {
      field: 'pricePerShare',
      headerName: 'Price Per Share',
      sortable: true,
      cellClass: 'flex align-items-center justify-content-left',
      type: 'w120',
      filter: true,
    },
    {
      field: 'investmentDate',
      headerName: 'Investment Date',
      sortable: true,
      cellClass: 'flex align-items-center justify-content-left',
      type: 'w120',
      filter: true,
    },
    {
      field: 'options',
      headerName: '',
      cellClass: 'flex align-items-center justify-content-center',
      type: 'w200',
      sortable: true,
      filter: true,
      cellRenderer: OptionCell,
    },
  ];
